import { ICONS } from "@constants/images";
import { gangstabetProfile } from "@misc/Links";
import { useEffect, useState } from "react";
import axios from "axios";

const NFTCard = ({ image, name, class_type, price, id }: any) => {
  function kFormatter(num: number) {
    return Math.abs(num) > 999
      ? Math.sign(num) * Number((Math.abs(num) / 1000).toFixed(1)) + "K"
      : Math.sign(num) * Math.abs(num);
  }

  return (
    <div
      className="nft__card animate__animated animate__fadeInLeft animate__delay-1s"
      onClick={() => window.open(gangstabetProfile + id, "_blank")}
    >
      <img className="nft__img" src={image} />
      <div className="nft__desc">
        <span className="nft__top_info">
          <span className="nft__name">{name}</span>
          {/* <span className="nft__type">{class_type}</span> */}
        </span>

        <span className="nft__amount">
          <img src={ICONS.ICON} width="14" />
          <span className="icx__price">{kFormatter(price)}</span>
          <span className="icx__unit">ICX</span>
        </span>
      </div>
    </div>
  );
};

export default NFTCard;
